<p-panel>
  <app-reactive-form-builder
    #formbuilder
    (formChanges)="formChanges($event[0], $event[1])"
    (goBack)="goBack()"
    (afterSend)="afterSend($event)"
    [form]="form.formFields"
    [serverUrl]="''"
    [dropdownLoadTrigger]="dropdownLoadTrigger"
    [dropdownsFinalized]="dropdownsFinalized"
    [id]="getModel().id"
    [request]="
      this.getType() === 1
        ? this.fincasApi.parcelasPUT
        : this.fincasApi.parcelasPOST
    "
    [getRequest]="this.fincasApi.parcelasGET"
  >
  </app-reactive-form-builder>
</p-panel>

<p-dialog
  [header]="'Mapa ' + form.parcelaNombre"
  [(visible)]="form.mapaAbierto"
  #mapaDialog
  (onShow)="scrollToTop()"
  [style]="{ width: '80vw' }"
  [appendTo]="'body'"
  [modal]="true"
  [style]="{'height': '75vh', 'width': '80vw'}"
>
  <div class="relative w-100 h-100">
    <app-mapa-add
      [origin]="origin"
      [finca]="form.finca"
      [localidad]="form.localidad"
      [cultivo]="form.cultivo"
      [variedad]="form.variedad"
      [parcelaNombre]="form.parcelaNombre"
      (fromMapa)="getFromMapa($event)">
    </app-mapa-add>
  </div>
</p-dialog>

<app-dialog-sigpac-form
  #sigpac
  (sendSigPac)="getSigPac($event)"
></app-dialog-sigpac-form>
